import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, unref as _unref, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { id: "title" }
const _hoisted_3 = { class: "description-wrapper" }
const _hoisted_4 = ["innerHTML"]

import { PropType, computed }from 'vue'
import PopUpMask from '@/modules/a.worksheets/views/components/feedback/PopUpMask.vue'
import { IonButton } from '@ionic/vue';



export default /*@__PURE__*/_defineComponent({
  __name: 'ModalMessage',
  props: {
    icon: String,
    title: {
        type: String,
        required: true    
    },
    description: {
        type: Object as PropType<Array<string>>
    },

    button: {
        type: Object as PropType<{textContent: string, danger: boolean, router?: string}>,
        required:true
    },
    showArrow : {
        type: Boolean, default: true
    }
},
  emits: ['button-click'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const buttonColor = computed(
    () => props.button.danger ? '--background: var(--milage-alert-color)' : '--background: var(--milage-color-primary)'
)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopUpMask, { "show-arrow": __props.showArrow }, {
    icon: _withCtx(() => [
      _createElementVNode("img", { src: __props.icon }, null, 8, _hoisted_1)
    ]),
    title: _withCtx(() => [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.title), 1)
    ]),
    description: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.description, (line, key) => {
          return (_openBlock(), _createElementBlock("span", {
            key: key,
            innerHTML: line
          }, null, 8, _hoisted_4))
        }), 128))
      ])
    ]),
    button: _withCtx(() => [
      _createVNode(_unref(IonButton), {
        style: _normalizeStyle(buttonColor.value),
        height: "2.575241849rem",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('button-click')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.button.textContent), 1)
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }, 8, ["show-arrow"]))
}
}

})